var map = {
	"./IMG_20230131_152356.jpg": 4551,
	"./IMG_20230131_152403.jpg": 7267,
	"./IMG_20230131_152407.jpg": 7448,
	"./IMG_20230131_152416.jpg": 4873,
	"./IMG_20230131_152420.jpg": 9885,
	"./img1.jpg": 5521,
	"./img2.jpg": 819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 553;